import { render, staticRenderFns } from "./LoanSubmissionError.vue?vue&type=template&id=5e639e66&scoped=true&"
import script from "./LoanSubmissionError.vue?vue&type=script&lang=js&"
export * from "./LoanSubmissionError.vue?vue&type=script&lang=js&"
import style0 from "./LoanSubmissionError.vue?vue&type=style&index=0&id=5e639e66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e639e66",
  null
  
)

export default component.exports